<a [routerLink]="link" class="inline-block mb-6">
	<img
		width="300"
		height="57"
		priority="true"
		[ngSrc]="'/assets/img/unicompare_MasterLogo.svg' | cdn"
		alt="Uni Compare Logo"
	/>
</a>
